import {Component} from 'react'

import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import actions from '../../../../redux/actions/ui/dataImport/strategies/productArchiveStrategy.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default class ProductArchiveStrategy extends Component {
  render() {
    return (
      <BaseStrategy
        {...this.props}
        actions={actions}
        EditForm={EditForm}
        ReconcileForm={ReconcileForm}
      />
    )
  }
}

ProductArchiveStrategy.title = actions.title
const option = {
  value: 'archive_product',
  display: 'Archive Products',
  category: 'products',
  Component: ProductArchiveStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
ProductArchiveStrategy.option = option
